import React from 'react';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const styles = (theme, x) => ({
  root: {
    color: 'white',
    borderRadius: 20,
    textTransform: 'unset',
    paddingRight: 25,
    paddingLeft: 25,
  },
});

const CmiButton = props => {
  const { classes, className: oldClassName, children, ...rest } = props;
  const customStyle = {};
  if (!rest.color) {
    customStyle.color = 'black';
  }
  const style = {
    ...customStyle,
    ...rest.style,
  };

  let className = classes.root;

  if (oldClassName) {
    className = classNames(classes.root, oldClassName);
  }

  return (
    <Button variant="contained" {...rest} className={className} style={style}>
      {children}
    </Button>
  );
};

export default withStyles(styles)(CmiButton);
